import Cookies from "js-cookie";

/**
 * Anti-DDoS shibboleth set on the client immediately before POSTing
 * to `/Customers/login-user`. The server rejects login requests that don't
 * carry it (LoginController.ts gates on this exact cookie name and value).
 * Rotating the value requires changing both the server check and every
 * caller of {@link setLoginPreCookie}.
 */
const LOGIN_PRE_COOKIE_NAME = "HbqYRnrCbWpm";
const LOGIN_PRE_COOKIE_VALUE = "vJcNkmBJdQUu";

/**
 * Sets the pre-cookie required by `/Customers/login-user`.
 *
 * @returns {void}
 */
export function setLoginPreCookie() {
	Cookies.set( LOGIN_PRE_COOKIE_NAME, LOGIN_PRE_COOKIE_VALUE );
}
